module.exports = __webpack_public_path__ + "static/media/client-google.6ef578ce.png";